module.exports = __webpack_public_path__ + "static/5-ca270baef0667dd83bc0526ab0934465.jpg";